// extracted by mini-css-extract-plugin
module.exports = {"ldsEllipsis":"Loader_ldsEllipsis__2tE3t","lds-ellipsis1":"Loader_lds-ellipsis1__mtto9","lds-ellipsis2":"Loader_lds-ellipsis2__38KnT","lds-ellipsis3":"Loader_lds-ellipsis3__1ENb3"};